import { makeVar } from '@apollo/client'

export const menuOptionsNotification = makeVar(false)
